import { render } from "./ContractsSeriesView.vue?vue&type=template&id=7f52b48a"
import script from "./ContractsSeriesView.vue?vue&type=script&lang=js"
export * from "./ContractsSeriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__